export default "__VITE_ASSET__CcQbMOl$__"